import { render, staticRenderFns } from "./registration-expired.vue?vue&type=template&id=0dd65a6a&scoped=true"
import script from "./registration-expired.vue?vue&type=script&lang=js"
export * from "./registration-expired.vue?vue&type=script&lang=js"
import style0 from "./registration-expired.vue?vue&type=style&index=0&id=0dd65a6a&prod&scoped=true&lang=css"
import style1 from "./registration-expired.vue?vue&type=style&index=1&id=0dd65a6a&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd65a6a",
  null
  
)

export default component.exports